//
//
//
//
//
//
//
//
//
//
//
import moment from 'dayjs';
var sourceData = [];
var beginDay = new Date().getTime();

for (var i = 0; i < 10; i++) {
  sourceData.push({
    x: moment(new Date(beginDay + 1000 * 60 * 60 * 24 * i)).format('YYYY-MM-DD'),
    y: Math.round(Math.random() * 10)
  });
}

export default {
  name: 'MiniArea',
  props: {
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // x 轴别名
    x: {
      type: String,
      default: 'x'
    },
    // y 轴别名
    y: {
      type: String,
      default: 'y'
    }
  },
  data: function data() {
    return {
      data: [],
      height: 100
    };
  },
  computed: {
    scale: function scale() {
      return [{
        dataKey: 'x',
        title: this.x,
        alias: this.x
      }, {
        dataKey: 'y',
        title: this.y,
        alias: this.y
      }];
    }
  },
  created: function created() {
    if (this.dataSource.length === 0) {
      this.data = sourceData;
    } else {
      this.data = this.dataSource;
    }
  }
};